module.exports = __webpack_public_path__ + "assets/img/machine.ae95e9bc.svg";